import { Link } from 'react-router-dom';

export interface NavItemData {
  label: string;
  path: string;
  icon?: string;
}

export interface NavItemProps {
  item: NavItemData;
  active?: boolean;
  collapsed?: boolean;
}

const cn = (...classes: (string | false | undefined)[]) => classes.filter(Boolean).join(' ');

// Single sidebar navigation row — extracted from the real app's
// layout/Sidebar.jsx so it can be previewed/reused on its own (e.g. in a
// tooltip wrapper when the sidebar is collapsed). Renders a react-router
// <Link>, so it needs a Router ancestor (the real app always has one; the
// Components showcase page runs inside BrowserRouter too).
export const NavItem = ({ item, active = false, collapsed = false }: NavItemProps) => {
  const itemClass = collapsed
    ? cn(
        'w-full justify-center px-0 h-12 text-white',
        active ? 'bg-[#3F707D]' : 'hover:bg-white/5',
      )
    : active
      ? 'w-full h-10 px-3 bg-[#3F707D] text-white rounded-[8px]'
      : 'w-full h-10 px-3 text-white hover:bg-white/5 rounded-[8px]';

  return (
    <Link
      to={item.path}
      className={cn('flex items-center transition-all duration-200 group gap-3', itemClass)}
    >
      {item.icon && (
        <img
          src={item.icon}
          alt=""
          className="shrink-0"
          style={{ width: collapsed ? 24 : 20, height: collapsed ? 24 : 20 }}
        />
      )}
      {!collapsed && (
        <span className="text-[14px] font-normal leading-none whitespace-nowrap flex-1">
          {item.label}
        </span>
      )}
    </Link>
  );
};
